import { render, staticRenderFns } from "./content.vue?vue&type=template&id=33972f1e&scoped=true&"
import script from "./content.vue?vue&type=script&lang=js&"
export * from "./content.vue?vue&type=script&lang=js&"
import style0 from "./content.vue?vue&type=style&index=0&id=33972f1e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33972f1e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33972f1e')) {
      api.createRecord('33972f1e', component.options)
    } else {
      api.reload('33972f1e', component.options)
    }
    module.hot.accept("./content.vue?vue&type=template&id=33972f1e&scoped=true&", function () {
      api.rerender('33972f1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/scenicTutorials/components/content.vue"
export default component.exports